import React,{useState,useEffect} from 'react'
import MaterialTable from 'material-table';
import Axios from 'axios';


import {MDBRow, MDBCol, MDBContainer,MDBIcon,MDBModal,MDBCard,MDBCardBody,
    MDBCardHeader,MDBCardFooter,MDBBtn,MDBBtnGroup  } from 'mdbreact';
    import { toast,ToastContainer } from 'react-toastify';



import "../css/scrollbar.css";

import AccessDenied from '../components/AccessDenied';



import AddEditSales from './AddEditSales';
import ViewSales from './ViewSales';
import AddEditBackOrder from './AddEditBackOrder';
import AddNewSales from './AddNewSales';



const SalesHistory=(props)=>{

  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [rows, setRows] = useState([]);
  const [showPreloader,setPreloader]=useState("normal");
  const [strTransactions,setTransactions]=useState("");
  const [selRow,setSelectedRow]=useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalAddEdit,showAddEdit]=useState(false);


  const toggleAddEdit = (transtype) => {

   
    setRows([]);
   
   
        showAddEdit(!modalAddEdit);
   
    loadData();
  
  }
  
 

  const toastId = React.useRef(null);

  const notify = (message) => {
      toastId.current = toast.info(message);
    
    }


  const [bRefresh,setRefresh]=useState(false);

 const refreshGrid =(message)=>{
   
     setRows([]);
      setRefresh(!bRefresh);
   
      loadData();
      notify(message);
      
    
    
  }


  const showResult =(message)=>{
    setRefresh(!bRefresh);
  
    setRows([]);
  
   
    // loadData(); 
  
    loadData();
   
  
    toast.info(message, {
        closeButton: false
        
      });
    
    
  }

  const [isAdmin,checkAdmin]=useState(0);


         
  function checkAdminAccess() {
      
  
    Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
     .then(res => {
     
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }
   
  function loadData() {
    
    Axios.get(props.apiServer + "/transactionslist?parentcode=" + props.parentcode,bearer)
     .then(res => {
       
       setRows(res.data);
        setPreloader("none");
    
     })
   
     .catch(error => {
      
      console.log(error);
     });  
    
   
   
   
   }



function ShowDeleted()
{
  setTransactions("");
  setPreloader("normal");
  setTransactions("deleted");
  loadData();
}

function ShowReturns()
{
  setTransactions("");
  setPreloader("normal");
  setTransactions("returns");
  loadData();
}
   
function ShowSales()
{
  setTransactions("");
  setPreloader("normal");
  setTransactions("sales");
  loadData();
}

function ShowAll()
{
  setPreloader("normal");
  setTransactions("");
  loadData();
}
  const useMountEffect = (functionName) => useEffect(functionName, [])


  useMountEffect(checkAdminAccess);
    // useMountEffect(loadData);

  

useEffect(() => {
  loadData();
 
}, [strTransactions]);

useEffect(() => {
  loadData();
 
}, [props.code]);


useEffect(() => {
  loadData();
 
}, [props.parentcode]);
if( isAdmin==0 ) 
{

  return (
    <React.Fragment>

    <AccessDenied />
    </React.Fragment>
   
    
    );
}
  
 

const TitleBar=()=>
{

return (

  <h6  style={{fontFamily:"Montserrat",fontWeight:"400"}} className="display-5 blue-grey-text ml-1"> Summary of Charges</h6>
);

}

  return (
    <React.Fragment > 


     
            { showPreloader==="normal" ? 
              ( 

                <MDBRow>
                <MDBCol md="4">

                </MDBCol>
                <MDBCol  md="4" className="text-center">
                <br/>  
                <img src={props.deployURL + "/loading.gif" } style={{width:"300px",textAlign:"center"}} alt="loading" />
                <br/>
                
                </MDBCol>
                <MDBCol  md="4">
                  
                </MDBCol>


              </MDBRow>
            
              )
              :
              (
                <React.Fragment>
                  
                        <MaterialTable

                                  title={<TitleBar></TitleBar>}



                                  columns={[
                                    
                                    { title: "Item", field: 'item'
                                      
                                    },

                                    { title: "code", field: 'code',hidden:true
                                      
                                    },
                                  
                                    { title: "Price", field: 'price',
                                      
                                    },

                                    { title: "Quantity", field: 'quantity',
                                      
                                    },

                                    { title: "Total Price", field: 'totalprice',
                                      
                                    },
                                  

                                  
                                  
                                    { title: 'Transaction Type', field: 'transactiontype', render: rowData =>(


                                          <>
                                          {rowData.transactiontype=='BACK ORDER' ? 
                                          (
                                            <span className="font-weight-bold red-text">
                                                { rowData.transactiontype}
                                            </span>
                                          )
                                          :
                                          (
                                            <span className="font-weight-bold black-text">
                                                  { rowData.transactiontype}
                                            </span>
                                          )
                                          }
                                          </>
                                        )

                                    }
                                  
                                  
                                  
                                  ]}




                                  data={rows
                                  }



                                
                                  options={{ 
                                    search: true,
                                    actionsColumnIndex: -1,
                                    pageSize: 50,
                                    pageSizeOptions: [ { value: rows.length, label: 'All' },5, 10, 20],
                                  }}




                                  detailPanel={[
                                  {
                                  icon: ()=> <MDBIcon icon="list" className="blue-text" />,
                                  openIcon: ()=><MDBIcon icon="chevron-circle-down"  className="red-text" />,
                                  tooltip:"Charge Details",
                                  render: rowData => {
                                  return (





                                    <MDBContainer className="ml-0" >
                                      <MDBCardHeader className="cloudy-knoxville-gradient">
                                            <span className="font-weight-bold"> Charge Details
                                              </span>
                                          </MDBCardHeader>  
                                        <MDBCardBody>
                                        <ViewSales
                                        deployURL={props.deployURL}
                                        apiServer={props.apiServer}
                                        code={rowData.code }
                                        parentcode={props.parentcode}
                                        dealercode={props.dealercode}
                                        apiServerHybrid={props.apiServerHybrid}
                                        returned={false}
                                          toggleModal={toggleAddEdit}
                                        refreshGrid={refreshGrid}
                                        // refreshSalesMain={props.refreshGrid}
                                        showResult={showResult}
                                        >

                                        </ViewSales>
                                        </MDBCardBody>
                                      <MDBCardFooter >
                                                
                                      </MDBCardFooter>

                                    </MDBContainer>


                                  )
                                  }

                                  }
                                    
                                  ,
                                  {
                                    icon: ()=> <MDBIcon icon="undo-alt" className="red-text" />,
                                    openIcon: ()=><MDBIcon icon="chevron-circle-down"  className="red-text" />,
                                    tooltip:"Back Order",
                                    render: rowData => {
                                    return (



                                  

                                      <MDBContainer className="ml-0" >
                                        <MDBCardHeader className="cloudy-knoxville-gradient">
                                            <span className="font-weight-bold"> Back Order
                                              </span>
                                          </MDBCardHeader>  
                                          <MDBCardBody>
                                        

                                      <AddEditBackOrder
                                        deployURL={props.deployURL}
                                        apiServer={props.apiServer}
                                        code={rowData.code }
                                        parentcode={props.parentcode}
                                        dealercode={props.dealercode}
                                        apiServerHybrid={props.apiServerHybrid}
                                        discountcode={props.discountcode}
                                        discounttype={props.discounttype}
                                        discountrate={props.discountrate}
                                        returned={true}
                                          toggleModal={toggleAddEdit}
                                        refreshGrid={refreshGrid}
                                        // refreshSalesMain={props.refreshGrid}
                                        showResult={showResult}
                                        >

                                        </AddEditBackOrder>
                                          </MDBCardBody>
                                        <MDBCardFooter >
                                                  
                                        </MDBCardFooter>

                                      </MDBContainer>


                                    )
                                    }

                                    }
                                      
                                    ]}

                                    />  

                        
                </React.Fragment>
              )
              
              
            
            }


          


          
            

          <ToastContainer
                hideProgressBar={true}
                newestOnTop={true}
                autoClose={2000}
               
                />
     {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
                  
    </React.Fragment>
   
  )
}



export default SalesHistory
